import React, { Fragment } from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import FormControl from '@material-ui/core/FormControl';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Button } from '@material-ui/core';

import Label from './Label';
import BetweenLabel from './BetweenLabel';

import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

import { AppState, IPageState } from '../../../appredux';

import { connect } from 'react-redux';
import moment from 'moment';
import MomentUtils from "@date-io/moment";
import { setLocale } from '../localeHelpers';

//PM 2021-08-06
export interface MuiDatePickerProps {
    page?: IPageState,
    dirtyBackground?: string,
    key: string | number,
    value: string | Date,
    minDate?: string | Date,
    maxDate?: string | Date,
    onChange: (date: MaterialUiPickersDate) => void,
    onAccept: (date: MaterialUiPickersDate) => void,
    onMinus: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
    onPlus: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
    leftBold?: boolean,
    rightBold?: boolean,
    formControlStyle?: React.CSSProperties,
    label?: string,
    betweenLabel?: string,
    labelSecondary?: boolean,
    labelBold?: boolean,
    labelBlock?: boolean,
    labelStyle?: React.CSSProperties,
    labelClasses?: string,
    style?: React.CSSProperties,
    inputStyle?: React.CSSProperties,
    className?: string,
    inputClasses?: string,
    cancelLabel?: string,
    showTodayButton?: boolean,
    todayLabel?: string,
    disabled?: boolean,
    endAdornment?: JSX.Element,
    noArrows?: boolean,
    formatNoDays?: boolean,
    touched?: boolean,
    error?: string,
    required?: boolean,
    placeholder?: string,
}

interface MuiDatePickerState {
    selected: boolean
}

class MuiDatePicker extends React.Component<MuiDatePickerProps & WithStyles<typeof styles>, MuiDatePickerState> {

    constructor(props: MuiDatePickerProps & WithStyles<typeof styles>) {
        super(props);
        this.state = { selected: false };
    }

    componentDidUpdate(prevProps: MuiDatePickerProps & WithStyles<typeof styles>) {
        if (!this.state.selected && prevProps.value !== this.props.value)
            this.setState({ selected: true });
    }

    //PM 2021-08-06
    datePicker = () => {
        const classes = this.props.classes;
        const lang = this.props.page && this.props.page.lang ? this.props.page.lang : 'pl';
        const secondaryLight = this.props.page && this.props.page.secondaryLight ? this.props.page.secondaryLight : '';

        return (
            <Fragment>
                <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={setLocale(lang)}>
                    <DatePicker
                        value={this.props.value} onChange={this.props.onChange}
                        onAccept={this.props.onAccept} format={this.props.formatNoDays? "YYYY-MM-DD" : "YYYY-MM-DD dddd"}
                        minDate={this.props.minDate} inputVariant="outlined"
                        maxDate={this.props.maxDate} placeholder={this.props.placeholder || undefined}
                        InputProps={{ classes: { input: this.props.inputClasses }, endAdornment: this.props.endAdornment }}
                        inputProps={{ style: this.state.selected ? { ...this.props.inputStyle, color: '' } : this.props.inputStyle }}
                        style={
                            this.state.selected || this.props.disabled
                                ? { ...this.props.style, backgroundColor: secondaryLight }
                                : { ...this.props.style, backgroundColor: '#ffffff' }
                        }
                        cancelLabel={this.props.cancelLabel ? this.props.cancelLabel : "wróć"}
                        showTodayButton={this.props.showTodayButton ? true : false}
                        todayLabel={this.props.todayLabel ? this.props.todayLabel : "dziś"}
                        disabled={this.props.disabled}
                        error={this.props.touched && Boolean(this.props.error)}
                        helperText={this.props.touched && this.props.error}
                    />
                </MuiPickersUtilsProvider>
                {!this.props.noArrows ? 
                <>
                <Button color="primary" variant="outlined"
                    className={`${classes.button} ${classes.marginButton}`}
                    style={{ width: "9%", fontWeight: this.props.leftBold ? "bold" : "normal" }} onClick={this.props.onMinus}
                    disabled={this.props.disabled}
                >
                    {'<'}
                </Button>
                <Button color="primary" variant="outlined"
                    className={`${classes.button} ${classes.marginButton}`}
                    style={{ width: "9%", fontWeight: this.props.rightBold ? "bold" : "normal" }} onClick={this.props.onPlus}
                    disabled={this.props.disabled}
                >
                    {'>'}
                </Button>
                </> : null}
            </Fragment>
        )
    }

    render() {
        const classes = this.props.classes;

        return (
            <Fragment>
                <FormControl
                    variant="outlined" margin="normal" fullWidth
                    className={classes.formControl}
                    style={this.props.formControlStyle}
                >
                    {this.props.betweenLabel ?
                        <BetweenLabel
                            label={this.props.betweenLabel}
                            secondary={this.props.labelSecondary}
                        />
                        :
                        <Label
                            label={this.props.label}
                            secondary={this.props.labelSecondary}
                            bold={this.props.labelBold}
                            block={this.props.labelBlock}
                            style={this.props.labelStyle}
                            className={this.props.labelClasses}
                            required={this.props.required}
                        />
                    }
                    {this.datePicker()}
                </FormControl>
            </Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    formControl: {
        marginTop: "0px",
        display: "block",
        //paddingBottom: "35px"
    },
    backgroundSecondary: {
        background: theme.palette.secondary.main
    },
    button: {
        height: "35px",
        minWidth: "0px",
        // padding: "6px 8px 5px",
        lineHeight: "13px",
        // textAlign: "center" as "center",
        // textTransform: "lowercase" as "lowercase",
        // border: "none",
        // color: "white",
        // borderRadius: "4px",
        // boxShadow: "0 2px 2px rgba(0,0,0,.2)",
        // textDecoration: "none",
        // fontWeight: 100,
        fontSize: "20px",
        // cursor: "pointer",
        // display: "inline-block"
    },
    marginButton: {
        margin: "0px 3px"
    },
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
    dirtyBackground: state.pageState.secondaryLight,
});

export default connect(mapStateToProps)(withStyles(styles)(MuiDatePicker));